@if (!!media) {
  @if (mobileMedia?.src) {
    <picture>
      @if (mobileMedia?.src) {
        <source
          srcset="{{mobileMedia?.src}}"
          media="(max-width: 767px)"
          [attr.width]="mobileMedia?.width"
          [attr.height]="mobileMedia?.height"
        />
      }
      @if (media.src) {
        <source
          srcset="{{media.src}}"
          media="(min-width: 768px)"
          [attr.width]="media.width"
          [attr.height]="media.height"
        />
      }
      <img
        [loading]="loading"
        [alt]="media.alt"
        [title]="media.alt"
        [src]="media.src"
        [attr.role]="media.role"
        [attr.width]="media.width"
        [attr.height]="media.height"
        [attr.fetchpriority]="loading === 'eager' ? 'high' : null"
        (load)="loadHandler()"
        (error)="errorHandler()"
      />
    </picture>
  } @else {
    @if (media.src) {
      <img
        [loading]="loading"
        [alt]="media.alt"
        [title]="media.alt"
        [src]="media.src"
        [srcset]="media.srcset || media.src"
        [attr.role]="media.role"
        [attr.width]="media.width"
        [attr.height]="media.height"
        [attr.sizes]="sizesForImgElement"
        [attr.fetchpriority]="loading === 'eager' ? 'high' : null"
        (load)="loadHandler()"
        (error)="errorHandler()"
      />
    }
  }
}
